import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { HistoryState } from '../type/history.type';

export const HistoryModel = Symbol('HistoryModel');

export interface HistoryModel extends AbstractModel<HistoryState> { }

@injectable()
export class HistoryModelImpl extends AbstractModelImpl<HistoryState> implements HistoryModel {
    protected _modelData: HistoryState = {
        showHistoryList: false,
        historyList: [],
        page: 0,
        total: 0,
        taskId: '',// todo: 删掉
        historyDetailTemp: {
            taskId: '',
            title: '',
        },
    };
}